import React from 'react';

const CategoryList = ({ categories, onDelete, onEdit }) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">
        Categorías
      </h3>

      {categories.length === 0 ? (
        <p className="text-gray-500">
          No hay categorías registradas
        </p>
      ) : (
        <ul className="divide-y divide-gray-200">
          {categories.map((category) => (
            <li
              key={category.id}
              className="py-3 flex justify-between items-center"
            >
              <span className="text-gray-700">
                {category.name}
              </span>

              <div className="flex gap-3">
                {/* BOTÓN EDITAR */}
                <button
                  onClick={() => onEdit(category)}
                  className="text-blue-500 hover:text-blue-700 transition duration-200"
                >
                  Editar
                </button>

                {/* BOTÓN ELIMINAR */}
                <button
                  onClick={() => onDelete(category.id)}
                  className="text-red-500 hover:text-red-700 transition duration-200"
                >
                  Eliminar
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoryList;
